"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Naise(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M6.693 8.337l9.626 13.349-9.651.015.025-13.364zm-3.305-4.1l.015 17.45c-1.294-.003-1.372-2.517-1.372-2.517v-.01-.358a5871.48 5871.48 0 0 1-.02-8.206v-.631V7.043c0-.55.002-.955.005-1.154.021-1.425 1.372-1.653 1.372-1.653zm18.473-.243c-.097 2.05-.568 14.781-.583 15.191v.01s.012 2.11-1.387 2.467l-.007-19.534 1.081-.126h.03c.164.004.954.122.866 1.992zm-5.252-1.439l-.007 14.375L6.92 3.774l9.689-1.219z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Naise;
